export default "__VITE_ASSET__CNJLgpUv__"